var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"title":"快速入口"}},[_c('ul',{staticClass:"quick-link"},_vm._l((_vm.linkList),function(item){return _c('li',{key:item.code,class:item.code,on:{"click":function($event){return _vm.linkHandle(item)}}},[_vm._v(" "+_vm._s(item.name)),_c('br'),_vm._v(_vm._s(item.remark)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }